<div class="tpl3pl-page-container tpl3pl-shipments">
	<div class="shipments-toolbar">
		<div class="shipments-row">
			<div class="shipments-group">
				<mat-form-field appearance="outline" class="tpl3pl-input">
					<mat-label>Filter by order number</mat-label>
					<mat-icon matPrefix>search</mat-icon>
					<input matInput [(ngModel)]="ordernoFilter" (keyup.enter)="loadShipments()" placeholder="Order number">
					<button *ngIf="ordernoFilter" matSuffix mat-icon-button (click)="ordernoFilter = ''; loadShipments()" type="button">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
			</div>
			<div class="shipments-group shipments-actions">
				<button mat-stroked-button (click)="openRawRequestResponse()" [disabled]="rawLoading" matTooltip="View raw API request/response for the selected date range">
					<mat-spinner *ngIf="rawLoading" diameter="18"></mat-spinner>
					<mat-icon *ngIf="!rawLoading">visibility</mat-icon>
					<span>View raw</span>
				</button>
				<button mat-raised-button color="primary" (click)="loadShipments()" [disabled]="loading">
					<mat-icon>refresh</mat-icon>
					<span>Refresh</span>
				</button>
			</div>
		</div>

		<div class="shipments-row shipments-poll-row">
			<div class="shipments-group shipments-date-range">
				<mat-form-field appearance="outline" class="tpl3pl-input tpl3pl-input-date">
					<mat-label>Poll from</mat-label>
					<input matInput [matDatepicker]="pollFromPicker" [(ngModel)]="pollDateStart" [max]="pollDateEnd">
					<mat-datepicker-toggle matSuffix [for]="pollFromPicker"></mat-datepicker-toggle>
					<mat-datepicker #pollFromPicker></mat-datepicker>
				</mat-form-field>
				<span class="tpl3pl-date-sep" aria-hidden="true">–</span>
				<mat-form-field appearance="outline" class="tpl3pl-input tpl3pl-input-date">
					<mat-label>Poll to</mat-label>
					<input matInput [matDatepicker]="pollToPicker" [(ngModel)]="pollDateEnd" [min]="pollDateStart">
					<mat-datepicker-toggle matSuffix [for]="pollToPicker"></mat-datepicker-toggle>
					<mat-datepicker #pollToPicker></mat-datepicker>
				</mat-form-field>
				<button mat-raised-button color="accent" (click)="pollShipments()" [disabled]="loading" class="tpl3pl-btn-poll" matTooltip="Poll PGS for B2B and B2C shipments in the selected date range">
					<mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
					<mat-icon *ngIf="!loading">sync</mat-icon>
					<span>Poll Shipments</span>
				</button>
			</div>
			<div class="shipments-group shipments-actions">
				<mat-form-field appearance="outline" class="tpl3pl-input tpl3pl-input-order">
					<mat-label>Check single order</mat-label>
					<input matInput [(ngModel)]="singleOrderToCheck" (keyup.enter)="checkSingleOrder()" placeholder="Order number">
				</mat-form-field>
				<mat-form-field appearance="outline" class="tpl3pl-input tpl3pl-input-channel">
					<mat-label>Channel</mat-label>
					<mat-select [(ngModel)]="checkOrderChannel" matTooltip="B2B only, B2C only, or both">
						<mat-option value="both">Both</mat-option>
						<mat-option value="b2b">B2B only</mat-option>
						<mat-option value="b2c">B2C only</mat-option>
					</mat-select>
				</mat-form-field>
				<button mat-stroked-button (click)="checkSingleOrder()" [disabled]="checkOrderLoading || !singleOrderToCheck?.trim()" [matTooltip]="checkOrderChannel === 'both' ? 'Fetch B2B and B2C shipment for this order from PGS' : 'Fetch ' + checkOrderChannel.toUpperCase() + ' shipment only'">
					<mat-spinner *ngIf="checkOrderLoading" diameter="18"></mat-spinner>
					<mat-icon *ngIf="!checkOrderLoading">manage_search</mat-icon>
					<span>Check order</span>
				</button>
			</div>
		</div>

		<div *ngIf="pollStatusMessage" class="shipments-poll-status">
			<mat-spinner diameter="20"></mat-spinner>
			<span>{{ pollStatusMessage }}</span>
		</div>
	</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading…</p>
		</div>
		<table class="table table-sm table-bordered w-100" [class.tpl3pl-loading-opacity]="loading">
			<thead>
				<tr>
					<th>Order Number</th>
					<th>Tracking Number</th>
					<th>Carrier</th>
					<th>Service Type</th>
					<th>Ship Date</th>
					<th>Delivery Date</th>
					<th>Phase</th>
					<th>Status</th>
					<th>Processed</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let item of shipments">
					<tr>
						<td>{{ item.orderno }}</td>
						<td class="tracking-cell" [matTooltip]="(item.tracking_number || '') ? item.tracking_number : null">{{ item.tracking_number || '-' }}</td>
						<td [matTooltip]="(item.carrier || '') ? item.carrier : null">{{ item.carrier || '-' }}</td>
						<td class="service-type-cell" [matTooltip]="(item.service_type || '') ? item.service_type : null">{{ item.service_type || '-' }}</td>
						<td>{{ item.ship_date | date:'shortDate' }}</td>
						<td>{{ item.delivery_date ? (item.delivery_date | date:'shortDate') : '-' }}</td>
						<td>
							<span class="badge phase-badge" [ngClass]="{
								'phase-pre-invoice': item.processed_phase === 'pre_invoice',
								'phase-auto-invoiced': item.processed_phase === 'auto_invoiced',
								'phase-invoice-failed': item.processed_phase === 'invoice_failed'
							}" [matTooltip]="item.invoice_message || phaseLabel(item.processed_phase)">
								{{ phaseLabel(item.processed_phase) }}
							</span>
						</td>
						<td><span class="badge badge-info">{{ item.status }}</span></td>
						<td>
							<mat-icon [ngClass]="{'text-success': item.processed, 'text-warning': !item.processed}">
								{{ item.processed ? 'check_circle' : 'schedule' }}
							</mat-icon>
						</td>
						<td>
							<button mat-icon-button (click)="toggleExpand(item)" matTooltip="View raw data">
								<mat-icon>{{ expandedShipmentId === item.id ? 'expand_less' : 'expand_more' }}</mat-icon>
							</button>
						</td>
					</tr>
					<tr *ngIf="expandedShipmentId === item.id" class="raw-data-row">
						<td colspan="10" class="p-2">
							<pre class="mb-0 p-2 bg-light small" style="max-height: 300px; overflow: auto;">{{ item.raw_data | json }}</pre>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="!loading && shipments.length === 0">
					<td class="text-center text-muted py-4" colspan="10">No shipments found.</td>
				</tr>
			</tbody>
		</table>

		<mat-paginator
			*ngIf="shipmentsTotal > 0"
			[length]="shipmentsTotal"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="pageSizeOptions"
			(page)="onPage($event)"
			showFirstLastButtons>
		</mat-paginator>
	</div>

	<div *ngIf="lastPollResult" class="mt-3">
		<div [ngClass]="{'alert-success': lastPollResult.success && lastPollResult.processed > 0, 'alert-warning': lastPollResult.success && lastPollResult.processed === 0, 'alert-danger': !lastPollResult.success}" class="alert d-flex justify-content-between align-items-center">
			<div>
				<strong>{{ !lastPollResult.success ? 'Poll failed:' : (lastPollResult.processed > 0 ? 'Poll complete:' : 'No shipments:') }}</strong> {{ lastPollResult.message }}
				<span *ngIf="lastPollResult.success && lastPollResult.processed !== undefined"> ({{ lastPollResult.processed }} processed)</span>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="lastPollResult = null">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div *ngIf="!lastPollResult.success && lastPollResult.response" class="mt-2">
			<details>
				<summary>API response</summary>
				<pre class="mb-0 p-2 bg-light small shipments-response-pre">{{ lastPollResult.response | json }}</pre>
			</details>
		</div>
	</div>
</div>
